module.exports = __webpack_public_path__ + "media/Video 85.9085e05a.mp4";